/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { accessListAIDetectionUsers } from "../funcs/accessListAIDetectionUsers.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListAIDetectionUsersResult } from "../models/components/listaidetectionusersresult.js";
import {
  ListAIDetectionUsersRequest,
  ListAIDetectionUsersSecurity,
} from "../models/operations/listaidetectionusers.js";
import { unwrapAsync } from "../types/fp.js";
export type AiDetectionUsersQueryData = ListAIDetectionUsersResult;

export function prefetchAiDetectionUsers(
  queryClient: QueryClient,
  client$: GramCore,
  request: ListAIDetectionUsersRequest,
  security?: ListAIDetectionUsersSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildAiDetectionUsersQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildAiDetectionUsersQuery(
  client$: GramCore,
  request: ListAIDetectionUsersRequest,
  security?: ListAIDetectionUsersSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<AiDetectionUsersQueryData>;
} {
  return {
    queryKey: queryKeyAiDetectionUsers({
      targetId: request.targetId,
      gramSession: request.gramSession,
    }),
    queryFn: async function aiDetectionUsersQueryFn(
      ctx,
    ): Promise<AiDetectionUsersQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(accessListAIDetectionUsers(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyAiDetectionUsers(
  parameters: { targetId: string; gramSession?: string | undefined },
): QueryKey {
  return ["@gram/client", "access", "listAIDetectionUsers", parameters];
}
